import { AlertProps } from "antd"

const RESET_ALERT: AlertProps = {
  type: undefined,
  message: "",
}

export default RESET_ALERT
